import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = {
  id: "update_api_drawer",
  class: "bg-white",
  "data-kt-drawer": "true",
  "data-kt-drawer-name": "add_api",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-width": "{default:'400px', 'md': '500px'}",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#update_api_drawer_toggle",
  "data-kt-drawer-close": "#update_api_drawer_close"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header pb-0 mb-0" }
const _hoisted_4 = { class: "d-flex align-items-center mb-7" }
const _hoisted_5 = { class: "d-flex flex-column" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", null, "Update API Connection", -1)
const _hoisted_7 = { class: "text-muted fw-bold" }
const _hoisted_8 = {
  class: "btn btn-sm btn-icon btn-active-icon-primary",
  id: "update_api_drawer_close"
}
const _hoisted_9 = { class: "svg-icon fw-bolder svg-icon-2" }
const _hoisted_10 = { class: "modal-body scroll-y mt-0 mb-0 m-5" }
const _hoisted_11 = { class: "w-100" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, "Alias", -1)
const _hoisted_15 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, "Username", -1)
const _hoisted_17 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, "Password", -1)
const _hoisted_19 = { class: "d-flex mb-5 fv-row" }
const _hoisted_20 = { class: "indicator-label" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Get Processors ")
const _hoisted_22 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_24 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, "Processor ID", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("option", null, null, -1)
const _hoisted_27 = ["value"]
const _hoisted_28 = { key: 1 }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, "alias", -1)
const _hoisted_30 = { class: "d-flex flex-column mb-2 fv-row" }
const _hoisted_31 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_32 = ["onUpdate:modelValue"]
const _hoisted_33 = { class: "d-flex flex-stack pt-15" }
const _hoisted_34 = { class: "indicator-label" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Submit ")
const _hoisted_36 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_alert = _resolveComponent("el-alert")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("span", _hoisted_7, "ID: " + _toDisplayString(_ctx.api.id), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, [
            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/abstract/abs012.svg" })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("form", {
          class: "mx-auto mw-600px w-100",
          novalidate: "novalidate",
          id: "update_api_form",
          onSubmit: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onSubmit()))
        }, [
          _createElementVNode("div", _hoisted_11, [
            (_ctx.api.connection_id === '1' && _ctx.api.endpoint_id === '1')
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control form-control-solid",
                      placeholder: "",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.alias_name) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.alias_name]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control form-control-solid",
                      placeholder: "",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.parameters.username) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.parameters.username]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control form-control-solid",
                      placeholder: "",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.parameters.password) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.parameters.password]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("button", {
                      type: "submit",
                      class: "btn btn-lg btn-primary",
                      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (
                    _ctx.getProcs(_ctx.parameters.username, _ctx.parameters.password)
                  ), ["prevent"])),
                      ref: "getProcsButton"
                    }, [
                      _createElementVNode("span", _hoisted_20, [
                        _hoisted_21,
                        _createElementVNode("span", _hoisted_22, [
                          _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                        ])
                      ]),
                      _hoisted_23
                    ], 512)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    (_ctx.isShowWarning)
                      ? (_openBlock(), _createBlock(_component_el_alert, {
                          key: 0,
                          title: "username/password incorrect",
                          type: "warning"
                        }))
                      : _createCommentVNode("", true),
                    _hoisted_25,
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select form-select-white form-select-sm form-control form-control-solid",
                      "data-control": "select2",
                      "data-placeholder": "Processor ID",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.parameters.processor_id) = $event))
                    }, [
                      _hoisted_26,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.procsData, (item, index) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: item,
                          key: index
                        }, _toDisplayString(item), 9, _hoisted_27))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.parameters.processor_id]
                    ])
                  ])
                ]))
              : (_ctx.parameters)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("div", _hoisted_30, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control form-control-solid",
                        placeholder: "",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.alias_name) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.alias_name]
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.parameters), (paramName, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "d-flex flex-column mb-2 fv-row",
                        key: index
                      }, [
                        _createElementVNode("label", _hoisted_31, _toDisplayString(paramName), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control form-control-solid",
                          placeholder: "",
                          "onUpdate:modelValue": ($event: any) => ((_ctx.parameters[paramName]) = $event)
                        }, null, 8, _hoisted_32), [
                          [_vModelText, _ctx.parameters[paramName]]
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-lg btn-primary",
                onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.formSubmit()), ["prevent"])),
                ref: "submitButton"
              }, [
                _createElementVNode("span", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("span", _hoisted_36, [
                    _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                  ])
                ]),
                _hoisted_37
              ], 512)
            ])
          ])
        ], 32)
      ])
    ])
  ]))
}